import { useFeatureServices } from '../../use-feature-services';
import { ObsConfig } from './ObsConfig';

export function useObsConfig(): ObsConfig {
  const { 'service-config-provider': serviceConfigProvider } = useFeatureServices();
  const config = serviceConfigProvider.configs['obs']!;

  if (!config) {
    throw new Error('useObsConfig hook was used before serviceConfig was loaded');
  }

  return config as ObsConfig;
}
